module.exports = __webpack_public_path__ + "static/media/icon-nav-easybuy.3003ef11.svg";